import Axios from 'axios';

export default {
  getVersion: () => Axios.get('/public/infos/version').then(resposne => resposne.data),
  getUrlPortail: () => Axios.get('/public/infos/url-portail').then(resposne => resposne.data)
};
